define('drops/dynamicText/dynamicText',[
    'jquery',
    'lq',
    'lq/drop',
    'lq/style',
    'lq/util',
    'lq/richText',
    'lq/html',
    'lq/constants',
    'lq/tooltip',
    'lq/onlongpress'
], function($, lq, Drop, Style, util, richText, html, constants, Tooltip, OnLongPress) {
    'use strict';

    var defaults = {
        data: {
            trimTextWithEllipsis: false,
            useDynamicWidth: true,
            useDynamicHeight: true,
            hideWhenEmpty: false,
            trimTextWithEllipsisMaxNumberOfLines: 1,
            title: {
                option: Tooltip.hardcoded
            },
            role: 'default'
        }
    };

    var base = Drop;
    function DynamicText(options) {
        base.call(this, $('<div/>'), defaults, options);

        this.data.eventing = util.convertListOfKeyValuesToObject(this.data.eventing) || {};

        this.$element
            .addClass('boxToBorderSize drop-text-container dynamic-text');

        this.$element
            .addClass('loading');

        new OnLongPress().applyLongPressOnElement(this.$element, this);

        if (this.data.eventing.clicked && this.data.eventing.clicked.enabled === true) {
            this.$element.addClass('clickable');
        }

        this.applyEventTrigger('mouseEnter', 'mouseenter');
        this.applyEventTrigger('mouseLeave', 'mouseleave');

        this.tooltip = new Tooltip(this, this.data.title, this.$element);
    };

    base.extend(DynamicText);

    DynamicText.typeName = 'DynamicText';

    DynamicText.prototype.showMockData = function (mockData) {
        this.setValue({ value: this.getMockTextToShow(mockData), type: constants.string });
    };

    DynamicText.prototype.getMockTextToShow = function (mockData) {
        return mockData;
    };

    DynamicText.prototype.updateMockData = function () {
        this.applyPosition();
    };

    DynamicText.prototype.preRender = function () {
        this.tooltip.update();

        this.piping.visibility.apply(this);
        this.formatter = this.piping.formatting.createFormatter(this.data.formatting);

        if (!this.data.hideWhenEmpty)
            this.showPlainText();
        else {
            this.hide();
        }

        if (this.data.mockData)
            this.showMockData(this.data.mockData);

        if (this.data.containImages) {
            this.$element.addClass('contain-images');
        }

        if (this.data.removeMarginAndPadding) {
            this.$element.addClass('remove-margin-and-padding');
        }

        this.applyPosition();
    };

    DynamicText.prototype.clearValue = function () {
        if (this.data.hideWhenEmpty)
            this.hide();
        else {
            if (this.$label)
                this.$label.text('');
            else
                this.richTextEditor.fromString('');
        }
    };

    DynamicText.prototype.rerenderLabel = function () {
        var text = this.text;

        if (this.data.renderAsHtml) {
            if (text) {
                var regex = new RegExp('{{{TenantUrl}}}', 'g');
                text = text.replace(regex, lq.getTenantUrl(''));
            }

            var $htmlWrapper = $('<div/>')
                .html(html.sanitize(text) || '');

            this.$label
                .empty()
                .append($htmlWrapper)
                .css({
                    whiteSpace: 'normal',
                    overflowWrap: 'break-word'
                });
        } else {
            if (this.data.stripHtml && text)
                text = html.strip(text);

            this.$label
                .text(text || '')
                .css({
                    whiteSpace: 'pre-wrap',
                    overflowWrap: 'break-word'
                });
        }

        if (this.data.trimTextWithEllipsis)
            this.tooltip.update(text);

        if (this.data.hideWhenEmpty) {
            if (text === null || text === undefined || text === '') {
                this.hide();
            } else {
                this.show();
            }
        }
    };

    DynamicText.prototype.setValue = function (update) {
        this.$element
            .removeClass('loading');

        update.value = update.value === null || update.value === undefined || update.value === '' ? this.data.defaultValue : update.value;

        if (richText.isRichTextString(update.value)) {
            this.hidePlainText();
            this.showRichText();
            this.richTextEditor.fromString(update.value);
            this.show();
        } else {
            this.hideRichText();
            this.showPlainText();

            this.text = this.formatter.convertFromLicquidFormat(update.type, update.value);
            this.rerenderLabel();
        }
    };

    // backwards compatibility
    DynamicText.prototype.getValue = function () {
        if (this.$label)
            return this.$label.text();
        return null;
    };

    DynamicText.prototype.hideRichText = function () {
        if (this.richTextEditor) {
            this.richTextEditor.close();
            this.richTextEditor = null;
        }
    };

    DynamicText.prototype.hidePlainText = function () {
        if (this.$label) {
            this.$label.remove();
            this.$label = null;
        }
    };

    DynamicText.prototype.showRichText = function () {
        if (!this.richTextEditor) {
            this.richTextEditor = new richText.RichTextEditor({
                parentElement: this.$element,
                sections: this.data.sections,
                editable: false
            });

            this.renderStyles();
        }
    };

    DynamicText.prototype.renderStyles = function () {
        if (this.richTextEditor) {
            Style.renderStyles(this, null, this.richTextEditor.$element);
        } else {
            Style.renderStyles(this, null, this.$element);
        }
    };

    DynamicText.prototype.createLabelElement = function () {
        if (this.data.role === 'title') {
            return $('<h1 />')
                .addClass('ignore-default-headings');
        } else if (this.data.role === 'subtitle') {
            return $('<h2 />')
                .addClass('ignore-default-headings');
        } else if (this.data.role === 'label') {
            return $('<label />')
                .attr('for', this.rootDrop.instanceId + '_' + this.data.labelForDropId);
        } else {
            return $('<div />');
        }
    };

    DynamicText.prototype.showPlainText = function () {
        if (!this.$label) {

            if (this.data.trimTextWithEllipsis && !this.data.trimTextWithEllipsisBasedOnLineCount) {
                this.$labelWrapper = $('<div />')
                    .addClass('ellipsis')
                    .addClass('boxToBorderSize')
                    .css({
                        width: '100%',
                        height: '100%'
                    })
                    .appendTo(this.$element);

                this.$innerLabelWrapper = $('<div />')
                    .appendTo(this.$labelWrapper);

                this.$label = this.createLabelElement()
                    .addClass('drop-text-content')
                    .css({
                        whiteSpace: 'pre-wrap',
                        marginRight: '10px',
                        margin: '0'
                    })
                    .appendTo(this.$innerLabelWrapper);
            } else {
                this.$overflowWrapper = $('<div />')
                    .addClass('overflow-wrapper')
                    .appendTo(this.$element);

                this.$labelWrapper = $('<div />')
                    .css({
                        display: 'flex',
                        width: '100%',
                        height: '100%'
                    })
                    .appendTo(this.$overflowWrapper);

                this.$label = this.createLabelElement()
                    .addClass('boxToBorderSize drop-text-content')
                    .css({
                        display: 'flex',
                        flexDirection: 'column',
                        flex: '1 1 100%',
                        width: '100%',
                        height: '100%'
                    })
                    .appendTo(this.$labelWrapper);

                if (this.data.trimTextWithEllipsis && this.data.trimTextWithEllipsisBasedOnLineCount) {
                    this.$label = this.createLabelElement()
                        .css({
                            overflow: 'hidden',
                            display: '-webkit-box',
                            '-webkit-line-clamp': this.data.trimTextWithEllipsisMaxNumberOfLines.toString(),
                            '-webkit-box-orient': 'vertical',
                            width: '100%'
                        })
                        .appendTo(this.$label);
                }

                if (this.data.showScrollbar) {
                    this.$element.css({
                        overflowY: 'auto',
                        overflowX: 'hidden'
                    });
                }
            }

            this.renderStyles();
        }
    };

    DynamicText.prototype.rerenderDynamicText = function () {
        this.$element.empty();
        this.$label = null;
        this.showPlainText();
        this.rerenderLabel();
    };

    return DynamicText;
});
